import { useGetOsDetails } from '@/shared/modules/user-agent';
import { OS_TYPE } from '@/shared/modules/user-agent/constants';
import { isChromeNewerOrEqualVersion } from '@/shared/modules/user-agent/utils';

const CHROME_VERSIONS = {
  WinVersionWithTopDownloads: '115.0.5790.110',
  MacOSVersionWithTopDownloads: '115.0.5790.114',
};

export const useIsChromeWithTopDownloads = () => {
  const { osType } = useGetOsDetails();

  const chromeVersionWithTopArrow =
    osType === OS_TYPE.MAC_OS
      ? CHROME_VERSIONS.MacOSVersionWithTopDownloads
      : CHROME_VERSIONS.WinVersionWithTopDownloads;

  return !!isChromeNewerOrEqualVersion(chromeVersionWithTopArrow);
};
